const SHARE_MESSAGE = "I just pre-registered for RelayRigs — a new marketplace connecting drivers with relief loads, owner-operator gigs, and RV delivery opportunities. Join the founding network with me:";

// Builds the referral link + share text/handlers for the post-signup success screen.
export const usePreRegisterShare = (referralCode) => {
  const referralLink = referralCode ? `${window.location.origin}/?ref=${referralCode}` : "";
  const shareText = `${SHARE_MESSAGE} ${referralLink}`;

  const copyReferralLink = (onCopied) => {
    navigator.clipboard.writeText(shareText);
    onCopied?.();
  };

  const shareTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`, "_blank", "noopener,noreferrer");
  };

  const shareSMS = () => {
    window.location.href = `sms:?body=${encodeURIComponent(shareText)}`;
  };

  const shareEmail = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent("Join me on RelayRigs")}&body=${encodeURIComponent(shareText)}`;
  };

  return { referralLink, shareText, copyReferralLink, shareTwitter, shareSMS, shareEmail };
};
